import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';

import PetItem from './PetItem';
import ErrorBanner from './ErrorBanner';
import getAvailablePets from '../../../selectors/getAvailablePets';
import getComingSoonPets from '../../../selectors/getComingSoonPets';
import getCollectedPets from '../../../selectors/getCollectedPets';
import getNewPets from '../../../selectors/getNewPets';


function getName(pet) {
	if (pet.localeData) {
		const thisLocale = _.find(pet.localeData, ['languageCode', 'all']) || _.find(pet.localeData, ['languageCode', 'en-US']);
		return _.get(thisLocale, 'title');
	}
	// If there's no locale data, its displayName is defined in constants.
	return pet.displayName;
}

function getPrice(pet) {
	const priceData = _.find(pet.prices, ['currencyCode', 'USD']);
	let price = 1;

	// If there's no USD price, just return 1.
	if (!priceData) {
		return price;
	}

	price = priceData.valueMicros * 0.000001; // Turn micros to dollars.
	price = parseInt(price.toFixed(0), 10); // Give it no decimals, turn it to number.
	return price;
}

function getIsActive(pet, activePet) {
	return activePet.petType.name === pet.petType.name;
}

class PetList extends React.Component {
	constructor() {
		super();
		this.state = {
			newAvailablePets: [],
			isOpen: false,
		};

		this.isOpenTimeout = null;
	}

	componentDidMount() {
		// Save the new availablePets to state, so that when they're cleared by the PetPicker we still can show what's new.
		this.setState({ newAvailablePets: this.props.newAvailablePets });
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.isOpen !== this.props.isOpen) {
			this.togglePetList(nextProps.isOpen);
		}

		// When the PetPicker was open and then gets closed, clear our state to reflect the updated redux store.
		if (this.props.isOpen && !nextProps.isOpen && !_.isEmpty(this.state.newAvailablePets)) {
			this.setState({ newAvailablePets: [] });
			return;
		}

		if (!_.isEmpty(nextProps.newAvailablePets)) {
			this.setState({ newAvailablePets: nextProps.newAvailablePets });
		}
	}

	togglePetList(willBeOpen) {
		clearTimeout(this.isOpenTimeout);

		if (willBeOpen) {
			this.setState({ isOpen: true });
		} else {
			this.isOpenTimeout = setTimeout(() => {
				this.setState({ isOpen: false });
			}, 500);
		}
	}

	render() {
		if (!this.state.isOpen) {
			return null;
		}

		return (
			<div className="pet-picker__list">
				<ErrorBanner error={this.props.error} />
				{this.props.availablePets.map(pet => (
					<PetItem
						key={pet.sku}
						petType={pet.petType}
						name={getName(pet)}
						price={getPrice(pet)}
						sku={pet.sku}
						isActive={getIsActive(pet, this.props.activePet)}
						moreThanOneCollectedPet={this.props.moreThanOneCollectedPet}
						isCollected={pet.isCollected}
						isNew={_.find(this.state.newAvailablePets, ['sku', pet.sku])}
						purchaseLoading={_.get(this.props.purchases[pet.sku], 'isLoading')}
						purchaseSuccess={_.get(this.props.purchases[pet.sku], 'success')}
						closePetPicker={this.props.closePetPicker}
					/>
				))}
				{this.props.comingSoonPets.map(pet => (
					<PetItem
						isComingSoon
						key={pet.sku}
						petType={pet.petType}
						name={getName(pet)}
						sku={pet.sku}
					/>
				))}
			</div>
		);
	}
}

// TODO prop validation
PetList.PropTypes = {
	activePet: PropTypes.shape({
		sku: PropTypes.string,
		type: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	}),
};

const mapStateToProps = state => ({
	moreThanOneCollectedPet: getCollectedPets(state.allPets).length > 1,
	availablePets: getAvailablePets(state.allPets),
	newAvailablePets: getNewPets(state.allPets),
	comingSoonPets: getComingSoonPets(state.allPets),
	activePet: state.activePet.active,
	error: state.lastVerification.error,
	purchases: state.purchases,
});

export default connect(mapStateToProps)(PetList);



// WEBPACK FOOTER //
// ./src/components/Extension/PetPicker/PetList.js